import { render, staticRenderFns } from "./CollectionsCreate.vue?vue&type=template&id=052deb89&"
import script from "./CollectionsCreate.vue?vue&type=script&lang=ts&"
export * from "./CollectionsCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports